// extracted by mini-css-extract-plugin
export default {"stateReasonLink":"ClosedEvent-module__stateReasonLink__XK4aG04","closerLink":"ClosedEvent-module__closerLink__qs2Umo2"};